import { useState } from "react";
import { Button, ListSubheader, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface SelectOption {
  value: string;
  label: string;
  category?: boolean;
}

interface DropdownProps {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  size?: "small" | "medium";
  variant?: "text" | "outlined" | "contained";
  fullWidth?: boolean;
}

export const Dropdown = ({
  options,
  value,
  onChange,
  size = "small",
  variant = "text",
  fullWidth = false,
}: DropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (optionValue: string) => {
    onChange(optionValue);
    handleClose();
  };

  const selectedOption = options.find((option) => option.value === value);
  const selectedLabel = selectedOption?.label || "";

  const selectedLabelWithPrefix =
    options.findIndex((option) => option.value === value) > 2
      ? `At Least ${selectedLabel}`
      : selectedLabel;

  return (
    <>
      <Button
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        size={size}
        variant={variant}
        fullWidth={fullWidth}
        sx={{ textTransform: "none" }}
      >
        {selectedLabelWithPrefix}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {options.map((option) => {
          if (option.category) {
            return (
              <ListSubheader key={option.value} sx={{ lineHeight: "32px" }}>
                {option.label}
              </ListSubheader>
            );
          }

          return (
            <MenuItem
              key={option.value}
              onClick={() => handleItemClick(option.value)}
              selected={value === option.value}
            >
              {option.label}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
